import { employeeCreateDescription as description } from './description';
import { create as execute } from './execute';

export { description, execute };
